import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.SubmissionFieldTextarea';
import { withParagraphs } from '../../../../utils/strings';

export default function SubmissionFieldTextarea({ context, question, value }) {
  return withParagraphs(value, styles.submissionParagraph);
}

SubmissionFieldTextarea.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
